module.exports = __webpack_public_path__ + "static/media/11.773e7bd5.jpg";